/**
 * Componente Mensagem
 * Descrição: Exibe uma mensagem ou notificação para o usuário.
 * 
 */

import './Mensagem.css';

const Mensagem = ({ mensagem, tipo }) => {
    if (!mensagem) return null; // Não renderiza nada se não houver mensagem
    
    return (
        <div className={`mensagem-container mensagem-${tipo}`} role="alert">
            {mensagem}
        </div>
    );
    

}

export default Mensagem;
